import { all, takeEvery, put, call, fork, race, take, delay, select } from 'redux-saga/effects';
import { RUNNING, SUCCEED, FAILED, CANCEL } from '@/constants/workflowStatus';
import { SUCCESS, CHECK_FAIL } from '@/constants/returnCode';
import { getWorkFlow, cancelWorkflow } from '@/services/api/v2/workflowCtrl';
import getDesignFile from '@/services/api/designFile';
import { TRANSLATION_SUCCESS, TRANSLATION_FAILED, GET_WORK_FLOWS, TRANSLATION_RUNNING, GET_TRANSLATION_MONITOR, CANCEL_UPLOAD_WORKFLOW } from './actionType';
import {
  translationProgress, translationSuccess, translationFailed,
  getWorkFlow as workFlowAction,
  translationMonitor, addMonitorMsg,
  translationDebug,
  changeDisableStatus
} from './action';
import { message } from 'antd';
import { getMonitor } from '@/services/workflow/workflow';
import { expandMenu } from '../../store/andes/action';
import { saveComponentsNetsInProject } from '../../store/project/action';

function* pollData(workflowId, projectID, designId) {
  try {
    yield delay(3000);
    yield put(workFlowAction(workflowId, projectID, designId));
  } catch (error) {
    return;
  }
}


const KEYARR = ['Statistics', 'Total counts', 'Layers:', 'Trace length',
  'Net histograms', 'Polygon edges', 'Pins:', 'Vias:'];
function filterContent(log) {
  try {
    if (KEYARR === 'undefined' || !(KEYARR instanceof Array) || KEYARR.length < 1) return false;
    const arrTxt = KEYARR.join('|'),
      regObj = new RegExp(arrTxt, 'ig');
    const _match = log.match(regObj);
    if (_match && _match.length > 0) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    console.log(e);
  }
}

function* dataFetch(action) {
  yield takeEvery(GET_WORK_FLOWS, function* (action) {
    const { workflowId, projectID, designId } = action;
    try {
      const response = (yield call(getWorkFlow, workflowId)).data;
      let monitor = yield call(getMonitor, workflowId);
      let _monitor = [], _debugMonitor = [];
      const progress = /[0-9]+[%]/g;
      for (let item of monitor) {

        // Filter progress bar
        const _match = item.log.match(progress);
        if (_match && _match.length > 0) {
          continue;
        }

        // Filter '' string
        if (!item.log) {
          continue;
        }

        // Filter debug log
        if (filterContent(item.log)) {
          _debugMonitor.push(item);
          continue;
        }

        _monitor.push(item);
      };
      yield put(translationMonitor(_monitor));
      yield put(translationDebug(_debugMonitor));
      if (response.code === SUCCESS) {
        const { data } = response;
        if (data.status === RUNNING) {
          const progress = parseInt(data.progress);
          const running = translationProgress({ workflowId, designId, projectID, progress: progress });
          yield put(running);
        }
        const { AndesReducer: { upload: { currentPCBKey } } } = yield select();
        if (data.status === SUCCEED) {
          const msg = `==> Finish compiling PCB.`
          const succeeded = translationSuccess(data.progress, msg);
          yield put(succeeded);
          const { AndesReducer: { andes: { expandedKeys }, project: { currentProjectId } } } = yield select();
          if (currentProjectId === projectID) {
            yield put({ type: 'ANDES/open_project', id: projectID });
            message.success('Upload completed!', 3);
            let Keys = [...expandedKeys];
            if (currentPCBKey && currentPCBKey !== 'replace' && !Keys.includes(currentPCBKey)) {
              Keys.push(currentPCBKey);
            }
            yield put(expandMenu([...Keys]));
          }

          if (currentPCBKey === 'replace') {
            yield put(saveComponentsNetsInProject([designId], true))
          }
          yield put(changeDisableStatus(false));
        }

        if (data.status === FAILED) {
          const msg = `==> Failed compiling PCB. \n==> ${data.message}`;
          const failed = translationFailed(msg, data.progress);
          yield put({ type: 'ANDES/open_project', id: projectID });
          yield put(failed);
          yield put(changeDisableStatus(false));

          if (currentPCBKey === 'replace') {
            yield put(saveComponentsNetsInProject([designId], true))
          }
        }

        if (data.status === CANCEL) {
          const msg = `==> Upload PCB closed.`;
          yield put(translationFailed(msg, 100));
          yield put(changeDisableStatus(false));
          if (currentPCBKey === 'replace') {
            yield put(saveComponentsNetsInProject([designId], true))
          }
        }
      } else if (response.code === CHECK_FAIL) {
        const msg = `==> Failed compiling PCB. \n` + response.msg;
        yield put(translationFailed(msg, 100));
        yield put(changeDisableStatus(false));
      }
    } catch (error) {
      yield put(addMonitorMsg(`==> Failed compiling PCB.`));
      const msg = `==> Failed compiling PCB. \n`;
      yield put(translationFailed(msg, 100));
      yield put(changeDisableStatus(false));
      console.error(error);
    }
  })
}

function* getLog(action) {
  yield takeEvery(GET_TRANSLATION_MONITOR, function* (action) {
    const { designId } = action;
    const response = yield call(getDesignFile, designId, 'lay_trans/log/layout_trans.log');
    let monitor = response ? response.data : null;
    yield put(translationMonitor(monitor));
  })
}

function* translationWork(action) {
  yield takeEvery(TRANSLATION_RUNNING, function* (action) {
    const { workflowId, designId, projectID } = action;
    try {
      yield race([
        call(pollData, workflowId, projectID, designId),
        take(TRANSLATION_SUCCESS),
        take(TRANSLATION_FAILED),
      ]);
    } catch (error) {
      console.error(error);
    }
  })
}

function* cancelUpload(action) {
  const { workflowId } = action;
  yield call(cancelWorkflow, workflowId);
}

export default function* FileUploadSaga() {
  yield all([
    fork(translationWork),
    fork(dataFetch),
    fork(getLog),
    takeEvery(CANCEL_UPLOAD_WORKFLOW, cancelUpload)
  ])
}